import { render, staticRenderFns } from "./MediaOwnersAdd.vue?vue&type=template&id=f674c0c2&"
import script from "./MediaOwnersAdd.vue?vue&type=script&lang=js&"
export * from "./MediaOwnersAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports